import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TextService } from './text.service';

@Pipe({ name: 'html' })
export class HtmlPipe implements PipeTransform {
  /* eslint-disable @angular-eslint/prefer-inject -- this pipe is manually constructed with `new` in several places (production code and tests), bypassing Angular DI; inject() only works within an active injection context and would throw NG0203 there */
  constructor(
    private readonly textService: TextService,
    private readonly sanitizer: DomSanitizer,
  ) {}
  /* eslint-enable @angular-eslint/prefer-inject */

  transform(value: string, params?: { [key: string]: string }): SafeHtml {
    const raw = this.textService.get(value, true, true, params);
    const sanitized = this.sanitizer.sanitize(SecurityContext.HTML, raw) ?? '';
    return this.sanitizer.bypassSecurityTrustHtml(sanitized);
  }
}
